import InputRightAddon from './InputRightAddon';

export default InputRightAddon;
